import { render, staticRenderFns } from "./TeachRoomDiscuss.vue?vue&type=template&id=6f90a956&scoped=true&"
import script from "./TeachRoomDiscuss.vue?vue&type=script&lang=js&"
export * from "./TeachRoomDiscuss.vue?vue&type=script&lang=js&"
import style0 from "./TeachRoomDiscuss.vue?vue&type=style&index=0&id=6f90a956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f90a956",
  null
  
)

export default component.exports